import React, { useRef, useState, useEffect, useContext } from "react";
import { ThumbnailPreview, mapBackendTemplateToFrontend } from "components/CommonComponents/CertificatePreview";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
  Collapse,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select, { components } from "react-select";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate, useParams } from "react-router-dom";
import {
  COURSE_LEVELS,
  COURSE_LANGUAGES,
  ADD_NEW_DOC_OPTION,
  COMPLETION_CRITERIA,
  VALIDITY,
  ADD_NEW_VALIDITY_OPTION,
  CRITERIA_DEPENDENT_OPTIONS,
  MODULES,
  ADD_NEW_COURSE,
  courseFieldToSectionMap,
  courseSectionLabels,
  VALIDATION_MODE,
  CERTIFICATE_TYPE_OPTIONS,
} from "components/constant";
import {
  SELECT_CUSTOM_STYLES,
  REGEX,
  MAX_THUMBNAIL_IMG_SIZE,
  MAX_DESCRIPTION_LENGTH,
} from "constants/CommonConstants";
import AddDocumentModal from "./AddDocumentModal";
import CertificateTemplateModal from "./CertificateTemplateModal";
import LessonsSection from "./LessonSection";
import InfoPopover from "components/CommonComponents/InfoPopover";
import { NotificationContext } from "components/CommonComponents/NotificationProvider";
import {
  getCourseNameList,
  addCourseName,
  deleteCourseName,
  addCourseDocument,
  getCourseDocumentList,
  addCourse,
  getCourseById,
  inactiveCourseBatches,
} from "action/course";
import {
  showAlert,
  toTitleCase,
} from "components/CommonComponents/CommonFunctions";
import { getCourseCategoryList } from "action/courseCategory";
import {
  urlDecodedId,
  urlEncodedId,
} from "components/CommonComponents/encodeDecodeFunction";


const initialState = {
  id: null,
  status: "",
  courseNameID: {
    value: "",
    error: "",
    isChanged: false,
  },
  courseCategoryID: {
    value: "",
    error: "",
    isChanged: false,
  },
  courseMedia: {
    value: null, //video/image
    error: "",
    isChanged: false,
  },
  courseDescription: {
    value: "",
    error: "",
    isChanged: false,
  },
  courseUsers: {
    // EXTERNAL | RAYCHEM | BOTH
    value: "",
    error: "",
    isChanged: false,
  },
  level: {
    value: "",
    error: "",
    isChanged: false,
  },
  // assessmentType: {
  //   value: "",
  //   error: "",
  //   isChanged: false,
  // },
  accessType: {
    // PAID | FREE
    value: "",
    error: "",
    isChanged: false,
  },
  payingUserType: {
    // EXTERNAL | RAYCHEM | BOTH
    value: "",
    error: "",
    isChanged: false,
  },
  courseType: {
    // RECORDED | LIVE
    value: "",
    error: "",
    isChanged: false,
  },
  contentDeliveryMode: {
    value: "",
    error: "",
    isChanged: false,
  },
  // trainingCenterID: {
  //   value: "",
  //   error: "",
  //   isChanged: false,
  // },
  coursePrice: {
    value: "",
    error: "",
    isChanged: false,
  },
  courseLanguage: {
    value: [],
    error: "",
    isChanged: false,
  },
  // instructorName: {
  //   value: "",
  //   error: "",
  //   isChanged: false,
  // },
  requiredPrerequisiteDocuments: {
    value: null,
    error: "",
    isChanged: false,
  },
  coursePrerequisiteDocument: {
    value: [],
    error: "",
    isChanged: false,
  },
  notes: {
    value: "",
    error: "",
    isChanged: false,
  },
  enableCertificate: {
    value: null,
    error: "",
    isChanged: false,
  },
  completionCertificateTemplate: {
    value: "",
    error: "",
    isChanged: false,
  },
  participationCertificateTemplate: {
    value: "",
    error: "",
    isChanged: false,
  },
  courseCertificateIssuanceCriteria: {
    value: [...COMPLETION_CRITERIA], //array
    error: "",
    isChanged: false,
  },
  certificateTemplateType: {
    value: "",
    error: "",
    isChanged: false,
  },
  completionCertificateValidity: {
    value: "",
    error: "",
    isChanged: false,
  },
  criteriaValue: {
    value: {}, //object
    error: "",
    isChanged: false,
  },
  // courseCertificateTemplate: {
  //   value: "",
  //   error: "",
  //   isChanged: false,
  // },
};

function AddCourse() {
  const { id: encodedId } = useParams();
  const dispatch = useDispatch();
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const { notify } = useContext(NotificationContext);
  const role = authData?.role;
  const navigate = useNavigate();
  const quillRef = useRef(null);
  const courseLanguageRef = useRef(null);
  const courseTypeRef = useRef(null);
  const courseMediaRef = useRef(null);
  const [courseData, setCourseData] = useState(initialState);
  const [open, setOpen] = useState({
    general: true,
    configurations: !!encodedId,
    prerequisites: !!encodedId,
    system: !!encodedId,
    lessons: !!encodedId,
    certificate: !!encodedId,
  });
  const [modalOpen, setModalOpen] = useState({
    addNewCourse: false,
    addDocument: false,
    certificateTemplate: false,
    addValidity: false,
  });

  const [uiState, setUiState] = useState({
    showThumbnailPreview: false,
    saveDraftLoading: false,
    readyToPublishLoading: false,
    publishLoading: false,
  });
  const [certificateTemplatesData, setCertificateTemplatesData] = useState({
    completion: null,
    participation: null,
    activeType: null,
  });
  const [enableFullEditing, setEnableFullEditing] = useState(null);
  const [configEditFlag, setConfigEditFlag] = useState(null);
  const [hasAcceptedConfigEdit, setHasAcceptedConfigEdit] = useState(false);

  const courseNameListData = useSelector(
    (state) => state.course.courseNameList,
  );
  const courseDocumentListData = useSelector(
    (state) => state.course.courseDocumentList,
  );
  const courseCategoryListData = useSelector(
    (state) => state.courseCategory.courseCategoryList,
  );
  const [descriptionLength, setDescriptionLength] = useState(0);
  const lessonListData = useSelector((state) => state.lesson.lessonList);

  const courseOptions =
    courseNameListData?.data?.map((course) => ({
      value: course.courseName,
      id: course.ID,
      label: course.courseName,
      canDelete: course.canDelete,
    })) || [];

  const courseCategoryOptions =
    courseCategoryListData?.data?.courseCategories
      ?.filter((category) => (encodedId ? true : category.status === "ACTIVE"))
      .map((category) => ({
        value: category.ID,
        label: category.name,
      })) || [];

  useEffect(() => {
    getCourseNameList(dispatch);
    getCourseCategoryList(dispatch);
    getCourseDocumentList(dispatch);
  }, [dispatch]);

  const courseAlreadyFetched = useRef(false);

  useEffect(() => {
    if (!encodedId || !courseOptions.length || !courseCategoryOptions.length) {
      return;
    }

    if (courseAlreadyFetched.current) return;

    const courseId = urlDecodedId(encodedId);

    if (!courseId) return;

    courseAlreadyFetched.current = true;
    fetchCourseById(courseId);
  }, [encodedId, courseOptions.length, courseCategoryOptions.length]);

  useEffect(() => {
  if (!quillRef.current) return;

  const editor = quillRef.current.getEditor();

  const getVisibleLength = () => getQuillPlainLength(editor);

  // -------- KEYDOWN --------
  const handleKeyDown = (e) => {
    if (
      e.ctrlKey ||
      e.metaKey ||
      e.altKey ||
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key.startsWith("Arrow") ||
      e.key === "Tab" ||
      e.key === "Home" ||
      e.key === "End" ||
      e.key === "PageUp" ||
      e.key === "PageDown"
    ) {
      return;
    }

    const currentLength = getVisibleLength();
    const selection = editor.getSelection();
    const selectedLength = selection?.length || 0;

    if (e.key.length === 1) {
      const netAdded = 1 - selectedLength;
      if (currentLength + netAdded > MAX_DESCRIPTION_LENGTH) {
        e.preventDefault();
      }
      return;
    }

    if (e.key === "Enter") {
      if (currentLength + 1 - selectedLength > MAX_DESCRIPTION_LENGTH) {
        e.preventDefault();
      }
    }
  };

  // -------- PASTE --------
  // Let Quill handle the paste normally, then trim in text-change.
  // This avoids manual index math and keeps one source of truth.
  const handlePaste = (e) => {
    const pastedText =
      e.clipboardData?.getData("text/plain") ||
      e.clipboardData?.getData("text") ||
      "";

    if (!pastedText) return;

    const selection = editor.getSelection() || {
      index: getVisibleLength(),
      length: 0,
    };

    const remaining =
      MAX_DESCRIPTION_LENGTH -
      (getVisibleLength() - selection.length);

    if (remaining <= 0) {
      e.preventDefault();
      // notify(
      //   "warning",
      //   `Description cannot exceed ${MAX_DESCRIPTION_LENGTH} characters`,
      // );
      return;
    }

    // Count how many PLAIN characters the pasted text contributes
    // as Quill will store them (i.e. newlines count as 1, not 2).
    const normalizedPaste = pastedText.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

    if (normalizedPaste.length <= remaining) {
      // Fits — let Quill handle it natively (preserves formatting)
      return;
    }

    // Doesn't fit — insert manually, truncated, as plain text
    e.preventDefault();
    editor.deleteText(selection.index, selection.length);
    editor.insertText(
      selection.index,
      normalizedPaste.substring(0, remaining),
    );
  };

  // -------- TEXT CHANGE (safety net) --------
  // Guard: only run for user-driven changes, never for our own
  // insertText/deleteText calls or initial render.
  const handleTextChange = (delta, oldDelta, source) => {
    if (source !== "user") return;

    const len = getVisibleLength();
    if (len <= MAX_DESCRIPTION_LENGTH) return;

    const overflow = len - MAX_DESCRIPTION_LENGTH;
    // Trim from the very END of the document
    const end = editor.getLength() - 1;
    editor.deleteText(end - overflow, overflow, "silent");
  };

  editor.root.addEventListener("keydown", handleKeyDown);
  editor.root.addEventListener("paste", handlePaste);
  editor.on("text-change", handleTextChange);

  return () => {
    editor.root.removeEventListener("keydown", handleKeyDown);
    editor.root.removeEventListener("paste", handlePaste);
    editor.off("text-change", handleTextChange);
  };
}, [notify]);

useEffect(() => {
  if (!quillRef.current) return;
  const editor = quillRef.current.getEditor();

  const update = () => setDescriptionLength(getQuillPlainLength(editor));

  update();
  editor.on("text-change", update);
  return () => editor.off("text-change", update);
}, []);

  const fetchCourseById = async (courseId) => {
    try {
      const res = await getCourseById(courseId);

      if (res?.code !== 200) {
        notify("danger", res?.message || "Failed to fetch course");
        return;
      }

      const course = res.data;
      setEnableFullEditing(res?.data?.totalEnrolledUsers > 0); // If totalEnrolledUsers is greater than 0 then allow editing for lessons and certificate only
      setConfigEditFlag(course?.configEditFlag);

      const templatesList = course.certificateTemplates || course.courseCertificateTemplates || [];
      const compTemplateObj = templatesList.find(t => t.certificateType === "COMPLETION");
      const partTemplateObj = templatesList.find(t => t.certificateType === "PARTICIPATION");
      
      const hasCompletion = !!compTemplateObj;
      const hasParticipation = !!partTemplateObj;
      
      let certTemplateTypeValue = "";
      if (hasCompletion && hasParticipation) certTemplateTypeValue = "BOTH";
      else if (hasCompletion) certTemplateTypeValue = "COMPLETION";
      else if (hasParticipation) certTemplateTypeValue = "PARTICIPATION";

      const issuanceCriteria = compTemplateObj?.issuanceCriteria || course.issuanceCriteria || [];

      if (templatesList.length > 0) {
        setCertificateTemplatesData((prev) => ({
          ...prev,
          completion: compTemplateObj?.certificateTemplate ? {
            ...compTemplateObj,
            template: typeof compTemplateObj.certificateTemplate === "string" 
              ? JSON.parse(compTemplateObj.certificateTemplate) 
              : compTemplateObj.certificateTemplate,
            bg_path: compTemplateObj.bg_path || compTemplateObj.bgPath,
            name: compTemplateObj.name || compTemplateObj.templateName,
          } : prev.completion,
          participation: partTemplateObj?.certificateTemplate ? {
            ...partTemplateObj,
            template: typeof partTemplateObj.certificateTemplate === "string"
              ? JSON.parse(partTemplateObj.certificateTemplate)
              : partTemplateObj.certificateTemplate,
            bg_path: partTemplateObj.bg_path || partTemplateObj.bgPath,
            name: partTemplateObj.name || partTemplateObj.templateName,
          } : prev.participation,
        }));
      }

      setCourseData({
        ...initialState,

        id: course.ID,

        status: course.courseStatus,

        courseNameID: {
          value:
            courseOptions.find((opt) => opt.id === course.courseNameID) || null,
          error: "",
          isChanged: false,
        },

        courseCategoryID: {
          value:
            courseCategoryOptions.find(
              (opt) => opt.value === course.courseCategoryID,
            ) || null,
          error: "",
          isChanged: false,
        },

        courseDescription: {
          value: course.courseDescription || "",
          error: "",
          isChanged: false,
        },

        courseMedia: {
          value: course.thumbnailPath || null,
          error: "",
          isChanged: false,
        },

        courseUsers: {
          value: course.courseUsers || "",
          error: "",
          isChanged: false,
        },

        level: {
          value: course.level || "",
          error: "",
          isChanged: false,
        },

        accessType: {
          value: course.accessType || "",
          error: "",
          isChanged: false,
        },

        payingUserType: {
          value: course.payingUserType || "",
          error: "",
          isChanged: false,
        },

        coursePrice: {
          value: course.coursePrice || "",
          error: "",
          isChanged: false,
        },

        courseType: {
          value: course.courseType || "",
          error: "",
          isChanged: false,
        },

        contentDeliveryMode: {
          value: course.contentDeliveryMode || "",
          error: "",
          isChanged: false,
        },

        // assessmentType: {
        //   value: course.assessmentType || "",
        //   error: "",
        //   isChanged: false,
        // },

        courseLanguage: {
          value:
            course.courseLanguage
              ?.split("_")
              ?.map((lang) =>
                COURSE_LANGUAGES.find((item) => item.value === lang),
              )
              ?.filter(Boolean) || [],
          error: "",
          isChanged: false,
        },

        requiredPrerequisiteDocuments: {
          value: course.requiredPrerequisiteDocuments,
          error: "",
          isChanged: false,
        },

        coursePrerequisiteDocument: {
          value:
            course.coursePrerequisiteDocument?.map((doc) => ({
              value: doc.courseDocumentID,
              label: doc.courseDocumentName,
            })) || [],
          error: "",
          isChanged: false,
        },

        notes: {
          value: course.notes || "",
          error: "",
          isChanged: false,
        },

        enableCertificate: {
          value:
            course.enableCeritificate !== undefined
              ? course.enableCeritificate
              : course.enableCertificate || false,
          error: "",
          isChanged: false,
        },

        courseCertificateIssuanceCriteria: {
          value:
            issuanceCriteria && issuanceCriteria.length > 0
              ? issuanceCriteria.map((item) => ({
                  value: item.criteriaType,
                  label: toTitleCase(item.criteriaType),
                }))
              : [...COMPLETION_CRITERIA],
          error: "",
          isChanged: false,
        },

        /* this converts [
                  {
                    criteriaType: "PROGRESS",
                    criteriaValue: 100,
                  },
                  {
                    criteriaType: "ASSESSMENT",
                    criteriaValue: 80,
                  },
                  ] to
                  {
                    PROGRESS: {
                      value: 100,
                      error: "",
                    },
                    ASSESSMENT: {
                      value: 80,
                      error: "",
                    },
                  }
  Summary: converting array of objects into an object of objects
*/

        criteriaValue: {
          value: issuanceCriteria.reduce(
            (acc, item) => {
              acc[item.criteriaType] = {
                value: item.criteriaValue,
                label: item.criteriaValue,
                error: "",
              };
              return acc;
            },
            {},
          ),
          error: "",
          isChanged: false,
        },

        completionCertificateValidity: {
          value: (() => {
            if (!compTemplateObj) return "";
            const match = VALIDITY.find(
              (opt) =>
                opt.value.durationType === (compTemplateObj.durationType || "") &&
                opt.value.durationValue === (compTemplateObj.durationValue || 0)
            );
            if (match) return match;
            if (compTemplateObj.durationValue > 0 && compTemplateObj.durationType) {
              return {
                value: {
                  durationType: compTemplateObj.durationType,
                  durationValue: compTemplateObj.durationValue,
                },
                label: `${compTemplateObj.durationValue} ${toTitleCase(
                  (compTemplateObj.durationType || "").replace(/s$/i, ""),
                )}${compTemplateObj.durationValue > 1 ? "s" : ""}`,
              };
            }
            return "";
          })(),
          error: "",
          isChanged: false,
        },

        certificateTemplateType: {
          value: certTemplateTypeValue 
            ? { value: certTemplateTypeValue, label: toTitleCase(certTemplateTypeValue) } 
            : "",
          error: "",
          isChanged: false,
        },
      });
    } catch (error) {
      notify("danger", error?.message || "Failed to fetch course");
    }
  };

  const isReadOnly = Boolean(encodedId) && enableFullEditing === true;

  const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const hasVisibleText = (html = "") => {
    if (!html) return false;

    const el = document.createElement("div");
    el.innerHTML = html;

    return el.textContent.trim().length > 0;
  };

  const getValidationError = (name, value, action) => {
    const shouldValidateConfigurations =
      action === VALIDATION_MODE.READY || action === VALIDATION_MODE.PUBLISH;

    const trimmedValue = typeof value === "string" ? value.trim() : value;

    switch (name) {
      case "courseNameID":
        return !trimmedValue ? "Please enter course name" : "";

      case "courseCategoryID":
        return !value ? "Please select course category" : "";

      case "level":
        return !value ? "Please select course level" : "";

      case "courseDescription": {
        if (!hasVisibleText(value)) return "Please enter a course description";
        const el = document.createElement("div");
        el.innerHTML = value;
        const textLen = el.textContent.trim().length;
        if (textLen > MAX_DESCRIPTION_LENGTH)
          return `Course description cannot exceed ${MAX_DESCRIPTION_LENGTH} characters.`;
        return "";
      }

      case "courseUsers":
        return shouldValidateConfigurations && !value
          ? "Please select course for"
          : "";

      case "accessType":
        return shouldValidateConfigurations && !value
          ? "Please select course for"
          : "";

      case "courseLanguage":
        return shouldValidateConfigurations && (!value || value.length === 0)
          ? "Please select course language"
          : "";

      case "courseType":
        return shouldValidateConfigurations && !value
          ? "Please select course type"
          : "";

      // case "trainingCenterID":
      //   return (courseData.contentDeliveryMode.value === "OFFLINE" ||
      //     courseData.contentDeliveryMode.value === "BOTH") &&
      //     !value
      //     ? "Please select offline training center"
      //     : "";

      // case "assessmentType":
      //   return (courseData.contentDeliveryMode.value === "OFFLINE" ||
      //     courseData.contentDeliveryMode.value === "BOTH") &&
      //     !value
      //     ? "Please select assessment type"
      //     : "";

      // Required for ALL actions if PAID
      case "payingUserType":
        return courseData.accessType.value === "PAID" && !value
          ? "Please select paid for"
          : "";

      case "coursePrice":
        if (courseData.accessType.value !== "PAID") return "";

        if (!value) {
          return "Please enter course price";
        }

        if (!REGEX.OTP_STRING_REGEX.test(value)) {
          return "Enter a valid number";
        }

        return "";

      case "contentDeliveryMode":
        return courseData.courseType.value === "LIVE" && !value
          ? "Please select content delivery mode"
          : "";

      case "coursePrerequisiteDocument":
        return courseData.requiredPrerequisiteDocuments.value === true &&
          (!value || value.length === 0)
          ? "Please select required documents"
          : "";

      case "certificateTemplateType":
        return courseData.enableCertificate.value && !value
          ? "Please select certificate template type"
          : "";

      case "courseCertificateIssuanceCriteria":
        if (
          courseData.courseType.value !== "RECORDED" &&
          courseData.enableCertificate.value &&
          (certificateType === "COMPLETION" || certificateType === "BOTH")
        ) {
          const val = courseData.criteriaValue.value?.["ATTENDANCE"]?.value;
          if (val === undefined || val === null || val === "") {
            return "Please select an attendance requirement";
          }
        }

        return "";

      case "completionCertificateValidity":
        return courseData.enableCertificate.value &&
          (certificateType === "COMPLETION" || certificateType === "BOTH") &&
          !value
          ? "Please select certificate validity"
          : "";

      case "completionCertificateTemplate":
        return courseData.enableCertificate.value &&
          (certificateType === "COMPLETION" || certificateType === "BOTH") &&
          !certificateTemplatesData.completion?.template
          ? "Please select completion certificate template"
          : "";

      case "participationCertificateTemplate":
        return courseData.enableCertificate.value &&
          (certificateType === "PARTICIPATION" || certificateType === "BOTH") &&
          !certificateTemplatesData.participation?.template
          ? "Please select participation certificate template"
          : "";

      default:
        return "";
    }
  };

  const validateForm = (action) => {
    let newCourseData = { ...courseData };
    let hasError = false;

    let sectionsToOpen = {
      general: false,
      configurations: false,
      prerequisites: false,
      system: false,
      lessons: false,
      certificate: false,
    };

    Object.keys(newCourseData).forEach((key) => {
      if (
        !newCourseData[key] ||
        typeof newCourseData[key] !== "object" ||
        !("value" in newCourseData[key])
      ) {
        return;
      }

      newCourseData[key] = {
        ...newCourseData[key],
        error: getValidationError(key, newCourseData[key].value, action),
      };
    });

    const errorSections = new Set();

    for (const key in newCourseData) {
      if (
        !newCourseData[key] ||
        typeof newCourseData[key] !== "object" ||
        !("error" in newCourseData[key])
      ) {
        continue;
      }

      if (newCourseData[key].error) {
        hasError = true;

        const section = courseFieldToSectionMap[key];

        if (section) {
          sectionsToOpen[section] = true;
          errorSections.add(courseSectionLabels[section]);
        }
      }
    }

    if (hasError) {
      setOpen((prev) => ({
        ...prev,
        ...sectionsToOpen,
      }));
    }

    setCourseData(newCourseData);

    return {
      isValid: !hasError,
      errorSections: [...errorSections],
    };
  };

  const getCourseListingRoute = (role) => {
    switch (role) {
      case "SUPER_ADMIN":
        return "/super-admin/course";

      case "ADMIN":
        return "/admin/course";

      case "CHANNEL_PARTNER":
        return "/channel-partner/course";

      case "TRAINER":
        return "/instructor/course";

      default:
        return "/admin/course";
    }
  };

  // const handleOnCancel = () => {
  //   setCourseData(initialState);
  // };

  const handleBackNavigation = () => {
    if (courseData.id) {
      navigate(
        `${getCourseListingRoute(role)}/${urlEncodedId(courseData.id)}/details`,
      );
    } else {
      navigate(getCourseListingRoute(role));
    }
  };

  // const handlePreviewNavigation = () => {
  //   if (!courseData.id) return;

  //   navigate(
  //     `${getCourseListingRoute(role)}/${urlEncodedId(courseData.id)}/details`,
  //     {
  //       state: {
  //         fromAddCourse: true,
  //       },
  //     },
  //   );
  // };

  // const handlePreview = () => {
  //   const { isValid, errorSections } = validateForm(VALIDATION_MODE.DRAFT);

  //   if (!isValid) {
  //     notify(
  //       "danger",
  //       `Please complete the required fields in ${formatSections(
  //         errorSections,
  //       )} before previewing.`,
  //     );
  //     return;
  //   }

  //   if (!courseData.id) {
  //     notify("danger", "Please save the course as a draft before previewing.");
  //     return;
  //   }

  //   handlePreviewNavigation();
  // };

  const SectionHeader = ({ title, isOpen, onClick }) => (
    <div
      className="d-flex align-items-center cursor text-deep-blue"
      onClick={onClick}
    >
      <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`} />
      <h5 className="ml-2 mb-0 section-header-title">{title}</h5>
    </div>
  );

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(
      name,
      trimmedValue,
      VALIDATION_MODE.PUBLISH,
    );
    setCourseData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
        isChanged: true,
      },
    }));
  };

  const handleDescriptionChange = (value) => {
    handleInputChange("courseDescription", value);
  };

  const handleInputChange = (field, value) => {
    const CONFIG_FIELDS = ["courseUsers", "courseLanguage", "accessType", "payingUserType", "coursePrice", "courseType", "contentDeliveryMode"];

    if (CONFIG_FIELDS.includes(field)) {
      if (configEditFlag === true && !hasAcceptedConfigEdit) {
        showAlert({
          title: "On any change of this configurations batches of this course will be marked as inactive. Do you wish to continue?",
          type: "warning",
          confirmStyle: "deep-blue",
          cancelStyle: "secondary",
          confirmText: "Yes",
          cancelText: "No",
          onConfirm: async () => {
            if (encodedId) {
              const courseId = urlDecodedId(encodedId);
              try {
                const res = await inactiveCourseBatches(courseId);
                if (res?.code === 200) {
                  notify("success", res?.message || "Batches marked as inactive successfully");
                  await fetchCourseById(courseId);
                } else {
                  const message = Array.isArray(res?.message)
                    ? res.message
                        .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
                        .join(", ")
                    : res?.message || "Failed to mark batches inactive";
                  notify("danger", message);
                  return;
                }
              } catch (error) {
                notify("danger", error?.message || "Something went wrong");
                return;
              }
            }
            setHasAcceptedConfigEdit(true);
            applyInputChange(field, value);
          }
        });
        return;
      }
    }

    applyInputChange(field, value);
  };

  const applyInputChange = (field, value) => {
    setCourseData((prev) => {
      if (field === "enableCertificate" && value === false) {
        setCertificateTemplatesData({
          completion: null,
          participation: null,
          activeType: null,
        });

        return {
          ...prev,
          enableCertificate: {
            ...prev.enableCertificate,
            value: false,
            error: "",
            isChanged: true,
          },
          courseCertificateIssuanceCriteria: {
            ...prev.courseCertificateIssuanceCriteria,
            value: [],
            error: "",
            isChanged: true,
          },
          criteriaValue: {
            ...prev.criteriaValue,
            value: {},
            error: "",
            isChanged: true,
          },
          certificateTemplateType: {
            ...prev.certificateTemplateType,
            value: "",
            error: "",
            isChanged: true,
          },
          completionCertificateValidity: {
            ...prev.completionCertificateValidity,
            value: "",
            error: "",
            isChanged: true,
          },
          completionCertificateTemplate: {
            ...prev.completionCertificateTemplate,
            value: "",
            error: "",
            isChanged: true,
          },
          participationCertificateTemplate: {
            ...prev.participationCertificateTemplate,
            value: "",
            error: "",
            isChanged: true,
          },
        };
      }

      const updatedCourseData = {
        ...prev,
        [field]: {
          ...prev[field],
          value,
          error: "",
          isChanged: true,
        },
      };

      if (field === "enableCertificate" && value === true) {
        updatedCourseData.courseCertificateIssuanceCriteria = {
          ...prev.courseCertificateIssuanceCriteria,
          value: [...COMPLETION_CRITERIA],
          error: "",
          isChanged: true,
        };
      }

      if (
        (field === "courseUsers" && prev.accessType.value === "PAID") ||
        (field === "accessType" && value === "PAID")
      ) {
        const courseUsers =
          field === "courseUsers" ? value : prev.courseUsers.value;

        if (courseUsers === "EXTERNAL" || courseUsers === "RAYCHEM") {
          updatedCourseData.payingUserType = {
            ...prev.payingUserType,
            value: courseUsers,
            error: "",
            isChanged: true,
          };
        } else if (courseUsers === "BOTH") {
          updatedCourseData.payingUserType = {
            ...prev.payingUserType,
            value: "BOTH",
            error: "",
            isChanged: true,
          };
        }
      }

      return updatedCourseData;
    });
  };

  const handleThumbnailChange = (file) => {
    if (!file) return;

    const setError = (msg) => {
      notify("danger", msg);
      setCourseData((prev) => ({
        ...prev,
        courseMedia: {
          value: null,
          error: msg,
          isChanged: true,
        },
      }));
    };

    if (file.size > MAX_THUMBNAIL_IMG_SIZE) {
      return setError("Thumbnail image size exceeded");
    }

    const allowedTypes = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "video/mp4",
      "video/quicktime",
    ];

    if (!allowedTypes.includes(file.type)) {
      return setError("file must be jpg, jpeg, png, mp4, mov");
    }

    setCourseData((prev) => ({
      ...prev,
      courseMedia: {
        value: file,
        error: "",
        isChanged: true,
      },
    }));
  };

  const getQuillPlainText = (editor) => {
    const t = editor.getText() || "";
    return t.endsWith("\n") ? t.slice(0, -1) : t;
  };

  const getQuillPlainLength = (editor) => getQuillPlainText(editor).length;

  const handleCourseChange = (selected) => {
    if (!selected) {
      handleInputChange("courseNameID", "");
      return;
    }
    if (selected.value === "ADD_NEW") {
      // Open modal for adding a new course
      setModalOpen((prev) => ({ ...prev, addCourse: true }));
      return;
    }
    handleInputChange("courseNameID", selected);
  };

  const handleRequiredDocChange = (selectedOptions) => {
    if (!selectedOptions) {
      handleInputChange("coursePrerequisiteDocument", []);
      return;
    }
    // If "Add new document" is clicked
    const isAddNewClicked = selectedOptions.some(
      (opt) => opt.value === "ADD_NEW",
    );
    if (isAddNewClicked) {
      setModalOpen((prev) => ({
        ...prev,
        addDocument: true,
      }));
      return;
    }

    handleInputChange("coursePrerequisiteDocument", selectedOptions);
  };

  const handleValidityChange = (selectedOption) => {
    if (!selectedOption) {
      handleInputChange("completionCertificateValidity", "");
      return;
    }

    if (selectedOption.value === "ADD_NEW") {
      setModalOpen((prev) => ({
        ...prev,
        addValidity: true,
      }));
      return;
    }

    handleInputChange("completionCertificateValidity", selectedOption);
  };

  const DocumentOptions = (props) => {
    const { isSelected, label } = props;

    return (
      <components.Option {...props}>
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            className="mr-2"
          />

          <span>{label}</span>
        </div>
      </components.Option>
    );
  };

  // Plain option renderer for validity dropdown (no checkbox/radio)
  const ValidityOptionRenderer = (props) => {
    const { label } = props;
    return (
      <components.Option {...props}>
        <span>{label}</span>
      </components.Option>
    );
  };

  const handleTemplateSelection = (type) => {
    setCertificateTemplatesData((prev) => ({ ...prev, activeType: type }));
    setModalOpen((prev) => ({ ...prev, certificateTemplate: true }));
  };

  // Called when user applies a template from preview modal inside CertificateTemplateModal
  const handleTemplateApply = (template) => {
    setCertificateTemplatesData((prev) => {
      if (prev.activeType === "COMPLETION") {
        return { ...prev, completion: template };
      } else if (prev.activeType === "PARTICIPATION") {
        return { ...prev, participation: template };
      }
      return prev;
    });

    setModalOpen((prev) => ({
      ...prev,
      certificateTemplate: false,
    }));
  };

  const handleCancelTemplate = () => {
    setModalOpen((prev) => ({
      ...prev,
      certificateTemplate: false,
    }));
  };

  // const handleDownloadTemplate = async (template) => {
  //   if (!template?.template) return;

  //   try {
  //     const templateJson = typeof template.template === "string" 
  //       ? JSON.parse(template.template) 
  //       : template.template;
  //     const canvas = document.createElement("canvas");
  //     canvas.width = 900;
  //     canvas.height = 600;
  //     const ctx = canvas.getContext("2d");

  //     const imageUrl = templateJson.previewImage || "/certificate-bg.png";

  //     const loadImg = (url) =>
  //       new Promise((resolve, reject) => {
  //         const img = new Image();
  //         img.crossOrigin = "anonymous";
  //         img.onload = () => resolve(img);
  //         img.onerror = (err) => reject(err);
  //         img.src = url;
  //       });

  //     try {
  //       const bgImg = await loadImg(imageUrl);
  //       ctx.drawImage(bgImg, 0, 0, 900, 600);
  //     } catch (err) {
  //       notify("danger", "Could not load background image.");
  //       ctx.fillStyle = "#fff";
  //       ctx.fillRect(0, 0, 900, 600);
  //     }

  //     for (const item of templateJson.layout || []) {
  //       if (item.type === "text") {
  //         let extraStyles = {};
  //         try {
  //           let srcStr = item.Src ?? item.src;
  //           if (srcStr) {
  //             const jsonStart = srcStr.indexOf('{');
  //             if (jsonStart !== -1) {
  //               srcStr = srcStr.substring(jsonStart);
  //               extraStyles = JSON.parse(srcStr);
  //             }
  //           }
  //         } catch (e) {}
          
  //         const weight = extraStyles.fontWeight || item.FontWeight || item.fontWeight || "normal";
  //         const style = extraStyles.fontStyle || item.FontStyle || item.fontStyle || "normal";
  //         const weightStr = weight === "normal" ? "" : weight;
  //         const styleStr = style === "normal" ? "" : style;

  //         ctx.font = `${styleStr} ${weightStr} ${item.FontSize || item.fontSize || 24}px ${item.FontFamily || item.fontFamily || "Arial"}`.trim();
  //         ctx.fillStyle = item.Color || item.color || "#000";
          
  //         let align = (item.TextAlign || item.textAlign || "left").toLowerCase();
  //         if (align === "justify") align = "left"; // Canvas doesn't support justify natively
  //         ctx.textAlign = align;
          
  //         ctx.textBaseline = "top";
  //         const xPos = ((item.X ?? item.x) / 100) * 900;
  //         const yPos = ((item.Y ?? item.y) / 100) * 600;
  //         ctx.fillText(item.Text ?? item.text, xPos, yPos);
  //       } else if (item.type === "signature" || item.type === "image") {
  //         try {
  //           const sigImg = await loadImg(item.src);
  //           const xPos = (item.x / 100) * 900;
  //           const yPos = (item.y / 100) * 600;
  //           const imgWidth = (((item.scaleX || 0.5) * 32) / 100) * 900;
  //           const imgHeight = (imgWidth / sigImg.width) * sigImg.height;
  //           ctx.drawImage(sigImg, xPos, yPos, imgWidth, imgHeight);
  //         } catch {
  //           notify("danger", "Could not load image or signature.");
  //         }
  //       } else if (item.type === "shape" && item.shapeType === "line") {
  //         const xPos = (item.x / 100) * 900;
  //         const yPos = (item.y / 100) * 600;
  //         const x1 = item.x1 || 0;
  //         const x2 = item.x2 || 100;
  //         const lineWidth = ((x2 - x1) / 900) * 900; // technically just x2 - x1
  //         const strokeWidth = item.strokeWidth || 2;
          
  //         ctx.save();
  //         ctx.translate(xPos, yPos);
  //         if (item.angle) {
  //           ctx.rotate((item.angle * Math.PI) / 180);
  //         }
          
  //         ctx.fillStyle = item.stroke || "#000";
  //         ctx.fillRect(0, 0, lineWidth, strokeWidth);
  //         ctx.restore();
  //       }
  //     }

  //     const dataUrl = canvas.toDataURL("image/png");
  //     const link = document.createElement("a");
  //     link.href = dataUrl;
  //     link.download = "certificate_preview.png";
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (err) {
  //     try {
  //       const templateJson = JSON.parse(template.template);
  //       const imageUrl = templateJson.previewImage || "/certificate-bg.png";
  //       const link = document.createElement("a");
  //       link.href = imageUrl;
  //       link.download = "certificate_preview.png";
  //       link.target = "_blank";
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //     } catch (fallbackErr) {}
  //   }
  // };

  const validateRequiredLessons = (
    isEnglishSelected,
    isHindiSelected,
    hasEnglishLessons,
    hasHindiLessons,
    actionText,
    isLiveCourse,
  ) => {
    let hasRequiredLessons = true;
    let missingLessonMsg = "";

    if (isLiveCourse) {
      return { hasRequiredLessons, missingLessonMsg };
    }

    const languageKey =
      isEnglishSelected && isHindiSelected
        ? "BOTH"
        : isEnglishSelected
          ? "ENGLISH"
          : isHindiSelected
            ? "HINDI"
            : "NONE";

    switch (languageKey) {
      case "BOTH":
        if (!hasEnglishLessons && !hasHindiLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one english and one hindi lesson before ${actionText}.`;
        } else if (!hasEnglishLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one english lesson before ${actionText}.`;
        } else if (!hasHindiLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one hindi lesson before ${actionText}.`;
        }
        break;

      case "ENGLISH":
        if (!hasEnglishLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one english lesson before ${actionText}.`;
        }
        break;

      case "HINDI":
        if (!hasHindiLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one hindi lesson before ${actionText}.`;
        }
        break;

      case "NONE":
        if (!hasEnglishLessons && !hasHindiLessons) {
          hasRequiredLessons = false;
          missingLessonMsg = `Please add at least one lesson before ${actionText}.`;
        }
        break;

      default:
        break;
    }

    return {
      hasRequiredLessons,
      missingLessonMsg,
    };
  };

  const validateCourseBeforeSave = (action) => {
    const { isValid, errorSections } = validateForm(action);

    if (!isValid) {
      notify(
        "danger",
        `Please complete the required fields in ${formatSections(
          errorSections,
        )} before proceeding.`,
      );

      return false;
    }

    const isOfflineCourse = courseData.contentDeliveryMode.value === "OFFLINE";

    // Lessons are not mandatory for Offline courses
    if (isOfflineCourse) {
      return true;
    }

    const isEnglishSelected = courseData.courseLanguage.value?.some(
      (lang) => lang.value === "ENGLISH",
    );
    const isHindiSelected = courseData.courseLanguage.value?.some(
      (lang) => lang.value === "HINDI",
    );

    const hasEnglishLessons = lessonListData?.data?.englishLessons?.length > 0;
    const hasHindiLessons = lessonListData?.data?.hindiLessons?.length > 0;

    const actionText =
      action === VALIDATION_MODE.READY
        ? "marking the course as ready to publish"
        : "publishing the course";

    const { hasRequiredLessons, missingLessonMsg } = validateRequiredLessons(
      isEnglishSelected,
      isHindiSelected,
      hasEnglishLessons,
      hasHindiLessons,
      actionText,
      courseData.courseType.value === "LIVE",
    );

    if (
      action !== VALIDATION_MODE.DRAFT &&
      (!courseData.id || !hasRequiredLessons)
    ) {
      setOpen((prev) => ({
        ...prev,
        lessons: true,
      }));

      notify("danger", missingLessonMsg);
      return false;
    }

    return true;
  };

  const handleSaveDraft = (e) => {
    if (e) e.preventDefault();
    if (!validateCourseBeforeSave(VALIDATION_MODE.DRAFT)) return;

    showAlert({
      title: "Are you sure you want to save this course as a draft?",
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {
        handleAddCourse(VALIDATION_MODE.DRAFT, false);
      },
    });
  };

  const handlePublish = (e) => {
    if (e) e.preventDefault();
    if (!validateCourseBeforeSave(VALIDATION_MODE.PUBLISH)) return;

    const isPublished = courseData?.status === "PUBLISHED";

    showAlert({
      title: isPublished
        ? "Are you sure you want to save this course?"
        : "Are you sure you want to publish this course?",
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => {
        handleAddCourse(VALIDATION_MODE.PUBLISH);
      },
    });
  };

  // const createCriteriaOption = () => {
  //   return function CriteriaOption(props) {
  //     const { data, isSelected, innerRef, innerProps, selectProps } = props;
  //     const dependentOptions = selectProps.dependentOptions[data.value];
  //     const selectedValue = selectProps.criteriaValue[data.value];
  //     const isOpen = selectProps.openNestedKey === data.value;

  //     return (
  //       <div ref={innerRef} {...innerProps} className="px-2 py-1">
  //         <label className="d-flex align-items-center justify-content-between w-100">
  //           <div className="d-flex align-items-center cursor">
  //             <input
  //               type="checkbox"
  //               checked={isSelected}
  //               readOnly
  //               className="mr-2"
  //             />

  //             {data.label}
  //           </div>
  //           {dependentOptions && isSelected && (
  //             <i
  //               className={`fa fa-angle-${isOpen ? "up" : "down"} ml-2 cursor`}
  //               onMouseDown={(e) => {
  //                 e.preventDefault();
  //                 e.stopPropagation();
  //                 selectProps.setOpenNestedKey(isOpen ? null : data.value);
  //               }}
  //             />
  //           )}
  //         </label>
  //         {dependentOptions && isOpen && (
  //           <div className="ml-4 mt-2 border-left pl-3">
  //             {dependentOptions.map((opt) => (
  //               <label
  //                 key={opt.value}
  //                 className="d-flex align-items-center mb-1 cursor"
  //                 onMouseDown={(e) => {
  //                   e.preventDefault();
  //                   e.stopPropagation();
  //                   selectProps.onDependentChange(data.value, {
  //                     label: opt.label,
  //                     value: opt.value,
  //                   });
  //                 }}
  //               >
  //                 <input
  //                   type="radio"
  //                   name={`criteria-${data.value}`}
  //                   checked={selectedValue?.value === opt.value}
  //                   readOnly
  //                   className="mr-2"
  //                 />
  //                 {opt.label}
  //               </label>
  //             ))}
  //           </div>
  //         )}
  //       </div>
  //     );
  //   };
  // };

  const formatSections = (sections) => {
    if (sections.length === 1) return sections[0];
    if (sections.length === 2) return sections.join(" and ");

    return `${sections.slice(0, -1).join(", ")} and ${sections.at(-1)}`;
  };

  // const getCriteriaOptionLabel = (criteriaValue) => (option) => {
  //   const sub = criteriaValue[option.value];
  //   return sub ? `${option.label} – ${sub.label}` : option.label;
  // };

  // const handleCriteriaChange = (selected) => {
  //   const safeSelected = selected || [];
  //   const prevSelected =
  //     courseData.courseCertificateIssuanceCriteria.value || [];

  //   // Find items that were removed (unchecked)
  //   const removedKeys = prevSelected
  //     .filter((prev) => !safeSelected.some((s) => s.value === prev.value))
  //     .map((item) => item.value);

  //   // Clear criteriaValue for removed keys so they don't show pre-filled on re-selection
  //   if (removedKeys.length > 0) {
  //     const updatedCriteriaValue = { ...courseData.criteriaValue.value };
  //     removedKeys.forEach((key) => {
  //       delete updatedCriteriaValue[key];
  //     });
  //     setCourseData((prev) => ({
  //       ...prev,
  //       criteriaValue: {
  //         ...prev.criteriaValue,
  //         value: updatedCriteriaValue,
  //       },
  //     }));
  //   }

  //   handleInputChange("courseCertificateIssuanceCriteria", safeSelected);
  //   // auto-open nested dropdown for last selected item
  //   const lastSelected = safeSelected[safeSelected.length - 1];
  //   if (lastSelected && CRITERIA_DEPENDENT_OPTIONS[lastSelected.value]) {
  //     setOpenNestedKey(lastSelected.value);
  //   } else {
  //     setOpenNestedKey(null);
  //   }
  // };

  const courseDocumentOptions =
    courseDocumentListData?.data?.map((doc) => ({
      value: doc.ID,
      label: doc.documentName,
    })) || [];

  const handleAddLessonClick = async () => {
    let hasError = false;
    let missingFields = [];

    if (!courseData.courseLanguage.value?.length) {
      setCourseData((prev) => ({
        ...prev,
        courseLanguage: {
          ...prev.courseLanguage,
          error: "Please select course language",
        },
      }));
      missingFields.push("course language");
      hasError = true;
    }

    if (!courseData.courseType.value) {
      setCourseData((prev) => ({
        ...prev,
        courseType: {
          ...prev.courseType,
          error: "Please select course type",
        },
      }));
      missingFields.push("course type");
      hasError = true;
    }

    if (hasError) {
      setOpen((prev) => ({
        ...prev,
        configurations: true,
      }));

      setTimeout(() => {
        if (!courseData.courseLanguage.value?.length) {
          courseLanguageRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else if (!courseData.courseType.value && courseTypeRef.current) {
          courseTypeRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 200);

      notify(
        "danger",
        `Please select ${missingFields.join(" and ")} before adding lessons.`,
      );
      return false;
    }

    if (courseData.id) {
      return true;
    }

    return await handleAddCourse(VALIDATION_MODE.DRAFT, false);
  };

  const handleAddCourseName = async (courseName) => {
    try {
      const payload = {
        courseName,
        status: "ACTIVE",
      };

      const res = await addCourseName(payload);

      if (res?.code === 200) {
        notify("success", res?.message || "Course added successfully");

        await getCourseNameList(dispatch);

        const newCourseOption = {
          id: res?.data,
          value: courseName,
          label: courseName,
          canDelete: true,
        };

        handleInputChange("courseNameID", newCourseOption);

        setModalOpen((prev) => ({
          ...prev,
          addCourse: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to add course";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message || "Something went wrong");
    }
  };

  const handleDeleteCourse = (e, courseId, courseName) => {
    e.stopPropagation();

    showAlert({
      title: `Are you sure you want to delete "${courseName}"?`,
      type: "warning",
      confirmStyle: "deep-blue",
      cancelStyle: "secondary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: async () => {
        try {
          const res = await deleteCourseName(courseId);

          if (res?.code === 200) {
            notify("success", res?.message || "Course deleted successfully");

            getCourseNameList(dispatch);
          } else {
            const message = Array.isArray(res?.message)
              ? res.message
                  .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
                  .join(", ")
              : res?.message || "Failed to delete course";

            notify("danger", message);
          }
        } catch (error) {
          notify("danger", error?.message || "Something went wrong");
        }
      },
    });
  };

  const handleAddCourseDocument = async (documentName) => {
    try {
      const payload = {
        documentName,
      };

      const res = await addCourseDocument(payload);

      if (res?.code === 200) {
        // notify("success", res?.message || "Document added successfully");
        notify("success", "Required document added successfully");

        await getCourseDocumentList(dispatch);

        const newlyAddedDocument = courseDocumentListData?.data?.find(
          (doc) => doc.documentName === documentName,
        );

        if (newlyAddedDocument) {
          handleInputChange("coursePrerequisiteDocument", [
            ...courseData.coursePrerequisiteDocument.value,
            {
              value: newlyAddedDocument.ID,
              label: newlyAddedDocument.documentName,
            },
          ]);
        }

        setModalOpen((prev) => ({
          ...prev,
          addDocument: false,
        }));
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to add document";

        notify("danger", message);
      }
    } catch (error) {
      notify("danger", error?.message || "Something went wrong");
    }
  };

  const payloadTransformers = {
    courseNameID: (value) => value?.id,
    courseCategoryID: (value) => value?.value,
    // trainingCenterID: (value) => value?.value,

    courseLanguage: (value) => {
      const languages = value?.map((lang) => lang.value) || [];

      if (languages.includes("ENGLISH") && languages.includes("HINDI")) {
        return "ENGLISH_HINDI";
      }

      return languages.join("_");
    },

    coursePrerequisiteDocument: (value) =>
      value?.map((doc) => ({
        courseDocumentID: doc.value,
      })),

    coursePrice: (value) =>
      value === "" || value === null || value === undefined
        ? undefined
        : Number(value),
  };

  const handleAddCourse = async (
    action = VALIDATION_MODE.DRAFT,
    shouldNavigate = true,
  ) => {
    if (!validateCourseBeforeSave(action)) return false;

    const loadingKey =
      action === VALIDATION_MODE.DRAFT
        ? "saveDraftLoading"
        : action === VALIDATION_MODE.READY
          ? "readyToPublishLoading"
          : "publishLoading";

    try {
      setUiState((prev) => ({
        ...prev,
        [loadingKey]: true,
      }));
      const payload = {
        ...(courseData.id && {
          ID: Number(courseData.id),
        }),
        action,
      };

      Object.entries(courseData).forEach(([key, field]) => {
        if (
          key === "id" || 
          key === "courseMedia" || 
          key === "criteriaValue" ||
          key === "courseCertificateIssuanceCriteria" ||
          key === "certificateTemplateType" ||
          key === "completionCertificateValidity" ||
          key === "completionCertificateTemplate" ||
          key === "participationCertificateTemplate"
        ) {
          return;
        }

        if (!field || typeof field !== "object" || !("value" in field)) {
          return;
        }

        let value = field.value;

        if (payloadTransformers[key]) {
          value = payloadTransformers[key](value);
        }

        const isEmpty =
          value === "" ||
          value === null ||
          value === undefined ||
          (Array.isArray(value) && value.length === 0);

        if (isEmpty) {
          return;
        }

        payload[key] = value;
      });

      if (payload.enableCertificate) {
        const certificateType = courseData.certificateTemplateType.value?.value;

        const courseCertificateTemplates = [];

        if (certificateType === "COMPLETION" || certificateType === "BOTH") {
          let compTemplateData = certificateTemplatesData.completion;
          let templateString = "";
          if (compTemplateData) {
            let parsed = typeof compTemplateData.template === "string" 
              ? JSON.parse(compTemplateData.template) 
              : { ...(compTemplateData.template || {}) };
            
            if (compTemplateData.bg_path || compTemplateData.bgPath) {
              parsed.PreviewImage = compTemplateData.bg_path || compTemplateData.bgPath;
            }
            templateString = JSON.stringify(parsed);
          }
          
          courseCertificateTemplates.push({
            certificateType: "COMPLETION",
            certificateTemplate: templateString || "",
            durationType: courseData.completionCertificateValidity.value?.value?.durationType || "",
            durationValue: Number(courseData.completionCertificateValidity.value?.value?.durationValue || 0),
          });
        }

        if (certificateType === "PARTICIPATION" || certificateType === "BOTH") {
          let partTemplateData = certificateTemplatesData.participation;
          let templateString = "";
          if (partTemplateData) {
            let parsed = typeof partTemplateData.template === "string" 
              ? JSON.parse(partTemplateData.template) 
              : { ...(partTemplateData.template || {}) };
            
            if (partTemplateData.bg_path || partTemplateData.bgPath) {
              parsed.PreviewImage = partTemplateData.bg_path || partTemplateData.bgPath;
            }
            templateString = JSON.stringify(parsed);
          }
          
          courseCertificateTemplates.push({
            certificateType: "PARTICIPATION",
            certificateTemplate: templateString || "",
          });
        }

        payload.certificateType = certificateType;
        payload.courseCertificateTemplates = courseCertificateTemplates;
        if (courseData.courseType.value !== "RECORDED") {
          payload.courseCertificateIssuanceCriteria = courseData.courseCertificateIssuanceCriteria.value.map(
            (criteria) => ({
              criteriaType: criteria.value,
              value: Number(courseData.criteriaValue.value?.[criteria.value]?.value || 0),
            }),
          );
        }
      }

      const formData = new FormData();

      formData.append("course", JSON.stringify(payload));

      if (
        courseData.courseMedia.isChanged &&
        courseData.courseMedia.value instanceof File
      ) {
        formData.append("courseThumbnailImage", courseData.courseMedia.value);
      }

      const res = await addCourse(formData);

      if (res?.code === 200) {
        setCourseData((prev) => ({
          ...prev,
          id: res.data,
        }));

        notify("success", res?.message || "Course saved successfully");

        if (shouldNavigate) {
          navigate(getCourseListingRoute(role));
        } else {
          await fetchCourseById(res.data);
        }

        return true;
      } else {
        const message = Array.isArray(res?.message)
          ? res.message
              .map((err) => (err?.Msg ? err.Msg : JSON.stringify(err)))
              .join(", ")
          : res?.message || "Failed to save course";

        notify("danger", message);
        return false;
      }
    } catch (error) {
      notify("danger", error?.message || "Something went wrong");
      return false;
    } finally {
      setUiState((prev) => ({
        ...prev,
        [loadingKey]: false,
      }));
    }
  };

  const CourseOption = (props) => {
    const { data } = props;

    return (
      <components.Option {...props}>
        <div className="d-flex justify-content-between align-items-center w-100">
          <span>{data.label}</span>

          {data.canDelete && (
            <i
              className="fa fa-trash cursor"
              onClick={(e) => handleDeleteCourse(e, data.id, data.label)}
            />
          )}
        </div>
      </components.Option>
    );
  };

  const CourseMenu = (props) => {
    return (
      <components.Menu {...props}>
        {props.children}
        <div
          className="add-new-course-fixed"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleCourseChange(ADD_NEW_COURSE);
          }}
        >
          <span className="text-deep-blue font-weight-bold">
            {ADD_NEW_COURSE.label}
          </span>
        </div>
      </components.Menu>
    );
  };

  const DocumentMenu = (props) => {
    return (
      <components.Menu {...props}>
        {props.children}
        <div
          className="add-new-course-fixed"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleRequiredDocChange([{ value: "ADD_NEW" }]);
          }}
        >
          <span className="text-deep-blue font-weight-bold">
            {ADD_NEW_DOC_OPTION.label}
          </span>
        </div>
      </components.Menu>
    );
  };

  const ValidityMenu = (props) => {
    return (
      <components.Menu {...props}>
        {props.children}
        <div
          className="add-new-course-fixed"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleValidityChange(ADD_NEW_VALIDITY_OPTION);
          }}
        >
          <span className="text-deep-blue font-weight-bold">
            {ADD_NEW_VALIDITY_OPTION.label}
          </span>
        </div>
      </components.Menu>
    );
  };

  const certificateType = courseData.certificateTemplateType.value?.value;

  return (
    <>
      <AdminHeader />
      {(uiState.saveDraftLoading || uiState.publishLoading) && (
        <div className="logout-overlay">
          <div className="logout-card">
            <i className="fa fa-spinner fa-spin fa-2x text-deep-blue mb-4" />
            <div className="font-weight-bold text-dark">
              {uiState.saveDraftLoading
                ? "Saving course, please wait..."
                : "Publishing course, please wait..."}
            </div>
          </div>
        </div>
      )}
      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center ">
              <div
                className="d-flex align-items-center cursor text-white"
                onClick={handleBackNavigation}
              >
                <i className="fa-solid fa-angle-left mr-2" />
                <span className="font-weight-bold">Back</span>
              </div>
              {isReadOnly && (
                <span className="text-white bg-warning ml-3 px-2 py-1 mb-0 form-control-label">
                  Please note: You can edit lessons and certificate data only.
                </span>
              )}
            </div>

            {/*general info details*/}
            <Card className="mb-3 mt-3">
              <CardHeader>
                <SectionHeader
                  title="General"
                  isOpen={open.general}
                  onClick={() => toggle("general")}
                />
              </CardHeader>
              <Collapse isOpen={open.general}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Name{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Select
                          name="courseNameID"
                          isDisabled={!!encodedId}
                          options={courseOptions}
                          placeholder="Select course name"
                          styles={{
                            ...SELECT_CUSTOM_STYLES,
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "calc(15rem - 2.5rem)",
                            }),
                          }}
                          classNamePrefix="react-select"
                          value={courseData.courseNameID.value || null}
                          onChange={handleCourseChange}
                          components={{
                            Option: CourseOption,
                            Menu: CourseMenu,
                          }}
                          onBlur={() =>
                            handleOnBlur(
                              "courseNameID",
                              courseData.courseNameID.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          isClearable
                          className={
                            courseData.courseNameID.error ? "is-invalid" : ""
                          }
                        />
                        {courseData.courseNameID.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseNameID.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Category
                        </Label>
                        <span className="text-danger"> *</span>
                        <Select
                          name="courseCategoryID"
                          isDisabled={!!encodedId}
                          options={courseCategoryOptions}
                          placeholder="Select course category"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={courseData.courseCategoryID.value}
                          onChange={(selected) => {
                            handleInputChange(
                              "courseCategoryID",
                              selected || "",
                            );
                          }}
                          onBlur={(e) =>
                            handleOnBlur(
                              "courseCategoryID",
                              courseData.courseCategoryID.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          isClearable
                          className={
                            courseData.courseCategoryID.error
                              ? "is-invalid"
                              : ""
                          }
                        />
                        {courseData.courseCategoryID.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseCategoryID.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Level <span className="text-danger"> *</span>
                        </Label>
                        <Select
                          isDisabled={!!encodedId}
                          options={COURSE_LEVELS}
                          placeholder="Select course level"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={
                            COURSE_LEVELS.find(
                              (option) =>
                                option.value === courseData.level.value,
                            ) || null
                          }
                          onChange={(selected) => {
                            handleInputChange("level", selected.value);
                          }}
                          onBlur={(e) =>
                            handleOnBlur("level", courseData.level.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                          className={courseData.level.error ? "is-invalid" : ""}
                          isClearable
                        />
                        {courseData.level.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.level.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="8">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Description{" "}
                          <span className="text-danger"> *</span>
                        </Label>


                        <div
                          className={`course-description-quill quill-wrapper ${courseData.courseDescription.error ? "quill-invalid" : ""} ${isReadOnly ? "quill-disabled" : ""}`}
                        >
                          <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            modules={MODULES}
                            placeholder="Enter course description"
                            value={courseData.courseDescription.value}
                            onChange={handleDescriptionChange}
                            onBlur={() =>
                              handleOnBlur(
                                "courseDescription",
                                courseData.courseDescription.value,
                              )
                            }
                            readOnly={isReadOnly}
                          />
                        </div>
                        {(() => {
                        const el = document.createElement("div");
                        el.innerHTML = courseData.courseDescription.value || "";
                        el.querySelectorAll("br").forEach((br) => br.replaceWith("\n"));
                        el.querySelectorAll("p, div, li").forEach((node) => {
                          if (node.textContent) node.append("\n");
                        });
                        const raw = el.textContent || "";
                        // Strip the final trailing newline Quill adds
                        // const len = raw.endsWith("\n") ? raw.length - 1 : raw.length;

                        return (
                          <div className="d-flex justify-content-between align-items-center mt-1">
                        <div className="invalid-feedback d-block m-0">
                          {courseData.courseDescription.error || ""}
                        </div>
                        <div
                          className={`font-size-sm ${
                            descriptionLength > MAX_DESCRIPTION_LENGTH
                              ? "text-danger"
                              : "text-muted"
                          }`}
                        >
                          {descriptionLength}/{MAX_DESCRIPTION_LENGTH}
                        </div>
                      </div>
                        );
                      })()}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Thumbnail Image / Video
                        </Label>

                        <div
                          className={`thumbnail-upload-card ${
                            courseData.courseMedia.error
                              ? "profile-invalid"
                              : ""
                          } ${isReadOnly ? "thumbnail-disabled-bg" : ""}`}
                        >
                          <Input
                            innerRef={courseMediaRef}
                            type="file"
                            id="courseMedia"
                            accept="image/*,video/*"
                            className="d-none"
                            disabled={isReadOnly}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              handleThumbnailChange(file);
                              e.target.value = "";
                            }}
                          />

                          <div className="thumbnail-upload-label mb-0">
                            {courseData.courseMedia.value ? (
                              <div className="course-media-preview-container mt--2">
                                <div className="course-media-preview-wrapper">
                                  {!isReadOnly && <span
                                    className="course-remove-icon"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();

                                      setCourseData((prev) => ({
                                        ...prev,
                                        courseMedia: {
                                          value: null,
                                          error: "",
                                        },
                                      }));

                                      if (courseMediaRef.current) {
                                        courseMediaRef.current.value = "";
                                      }
                                    }}
                                  >
                                    &times;
                                  </span>}

                                  {typeof courseData.courseMedia.value ===
                                  "string" ? (
                                    /\.(mp4|webm|ogg|mov|m4v)$/i.test(
                                      courseData.courseMedia.value,
                                    ) ? (
                                      <video
                                        src={courseData.courseMedia.value}
                                        className="course-thumbnail-preview mb--3 cursor"
                                        controls
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setUiState((prev) => ({
                                            ...prev,
                                            showThumbnailPreview: true,
                                          }));
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={courseData.courseMedia.value}
                                        alt="thumbnail"
                                        className="course-thumbnail-preview mb--3 cursor"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setUiState((prev) => ({
                                            ...prev,
                                            showThumbnailPreview: true,
                                          }));
                                        }}
                                      />
                                    )
                                  ) : courseData.courseMedia.value?.type?.startsWith(
                                      "image/",
                                    ) ? (
                                    <img
                                      src={URL.createObjectURL(
                                        courseData.courseMedia.value,
                                      )}
                                      alt="thumbnail"
                                      className="course-thumbnail-preview mb--3 cursor"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setUiState((prev) => ({
                                          ...prev,
                                          showThumbnailPreview: true,
                                        }));
                                      }}
                                    />
                                  ) : (
                                    <video
                                      src={URL.createObjectURL(
                                        courseData.courseMedia.value,
                                      )}
                                      className="course-thumbnail-preview mb--3 cursor"
                                      controls
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setUiState((prev) => ({
                                          ...prev,
                                          showThumbnailPreview: true,
                                        }));
                                      }}
                                    />
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className="d-flex flex-column align-items-center">
                                <i className="fa fa-cloud-upload fa-2x text-muted"></i>

                                <p className="mb-0 mt-1 muted-label font-size-sm text-center">
                                  (Accepted formats: PNG, JPG, JPEG, MP4, MOV -
                                  Max 15MB)
                                </p>

                                <p className="mb-1 muted-label font-size-sm">
                                  Click to upload thumbnail
                                </p>

                                <label
                                  htmlFor="courseMedia"
                                  className={`choose-image-btn btn btn-simple btn-sm m-0 ${isReadOnly ? 'disabled' : ''}`}
                                >
                                  Choose File
                                </label>
                              </div>
                            )}
                          </div>
                        </div>

                        {courseData.courseMedia.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseMedia.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
            <div ref={courseLanguageRef} />
            {/* configurations details */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Configurations"
                  isOpen={open.configurations}
                  onClick={() => toggle("configurations")}
                />
              </CardHeader>
              <Collapse isOpen={open.configurations}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup check className="p-0">
                        <Label className="form-control-label">
                          Course For <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="courseForInfo"
                            title="Course For"
                            content="Determines which users can view and enroll in this course."
                          />
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseUsers"
                                checked={
                                  courseData.courseUsers.value === "EXTERNAL"
                                }
                                onChange={() =>
                                  handleInputChange("courseUsers", "EXTERNAL")
                                }
                                onBlur={() =>
                                  handleOnBlur(
                                    "courseUsers",
                                    courseData.courseUsers.value,
                                  )
                                }
                                disabled={courseData.courseUsers.value !== "EXTERNAL" && isReadOnly}
                              />
                              External Users
                            </Label>
                          </FormGroup>

                          <FormGroup check className="access-type-radio">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseUsers"
                                checked={
                                  courseData.courseUsers.value === "RAYCHEM"
                                }
                                onChange={() =>
                                  handleInputChange("courseUsers", "RAYCHEM")
                                }
                                onBlur={() =>
                                  handleOnBlur(
                                    "courseUsers",
                                    courseData.courseUsers.value,
                                  )
                                }
                                disabled={courseData.courseUsers.value !== "RAYCHEM" && isReadOnly}
                              />
                              Raychem
                            </Label>
                          </FormGroup>

                          <FormGroup className="access-type-radio">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseUsers"
                                checked={
                                  courseData.courseUsers.value === "BOTH"
                                }
                                onChange={() =>
                                  handleInputChange("courseUsers", "BOTH")
                                }
                                onBlur={() =>
                                  handleOnBlur(
                                    "courseUsers",
                                    courseData.courseUsers.value,
                                  )
                                }
                                disabled={courseData.courseUsers.value !== "BOTH" && isReadOnly}
                              />
                              Both
                            </Label>
                          </FormGroup>
                        </div>
                        {courseData.courseUsers.error && (
                          <div className="invalid-feedback d-block mt--2">
                            {courseData.courseUsers.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">Language</Label>
                        <span className="text-danger"> *</span>
                        <Select
                          isMulti
                          options={COURSE_LANGUAGES}
                          hideSelectedOptions={false}
                          closeMenuOnSelect={false}
                          placeholder="Select course language"
                          styles={{
                            ...SELECT_CUSTOM_STYLES,
                            option: (provided, state) => ({
                              ...provided,
                              backgroundColor: state.isFocused
                                ? "#f0f4ff"
                                : "transparent",
                              color: "#525f7f",
                            }),
                            multiValue: (provided) => ({
                              ...provided,
                              backgroundColor: "#e8eaf6",
                            }),
                            multiValueLabel: (provided) => ({
                              ...provided,
                              color: "#32325d",
                            }),
                          }}
                          classNamePrefix="react-select"
                          value={courseData.courseLanguage.value}
                          onChange={(selected) => {
                            handleInputChange("courseLanguage", selected || []);
                          }}
                          onBlur={(e) =>
                            handleOnBlur(
                              "courseLanguage",
                              courseData.courseLanguage.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          components={{ Option: DocumentOptions }}
                          menuPosition="absolute"
                          isClearable
                          className={
                            courseData.courseLanguage.error ? "is-invalid" : ""
                          }
                          isDisabled={isReadOnly}
                        />
                        {courseData.courseLanguage.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseLanguage.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Access Type <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="accessInfo"
                            title="Access Type"
                            content="Select whether learners need to pay to enroll in this course."
                          />{" "}
                        </Label>
                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="accessType"
                                checked={courseData.accessType.value === "PAID"}
                                onChange={() =>
                                  handleInputChange("accessType", "PAID")
                                }
                                disabled={courseData.accessType.value !== "PAID" && isReadOnly}
                              />
                              Paid
                            </Label>
                          </FormGroup>

                          <FormGroup check className="access-type-radio">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="accessType"
                                checked={courseData.accessType.value === "FREE"}
                                onChange={() =>
                                  handleInputChange("accessType", "FREE")
                                }
                                disabled={courseData.accessType.value !== "FREE" && isReadOnly}
                              />
                              Free
                            </Label>
                          </FormGroup>
                        </div>
                        {courseData.accessType.error && (
                          <div className="invalid-feedback d-block mt-1">
                            {courseData.accessType.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    {courseData.accessType.value === "PAID" && (
                      <>
                        <Col md="4">
                          <FormGroup check className="p-0">
                            <Label className="form-control-label">
                              Paid For
                              <span className="text-danger"> *</span>
                              <InfoPopover
                                targetId="paidForInfo"
                                title="Paid For"
                                content="Choose which users are required to pay for this course."
                              />
                            </Label>

                            <div className="d-flex mt-3">
                              <FormGroup check>
                                <Label check className={`cursor ${
                                    (courseData.courseUsers.value &&
                                      courseData.courseUsers.value !== "EXTERNAL" &&
                                      courseData.courseUsers.value !== "BOTH")
                                      ? "cursor-not-allowed"
                                      : ""
                                  }`}>
                                  <Input
                                    type="radio"
                                    name="payingUserType"
                                    checked={
                                      courseData.payingUserType.value ===
                                      "EXTERNAL"
                                    }
                                    disabled={
                                      (isReadOnly && courseData.courseUsers.value !== "EXTERNAL") || (courseData.courseUsers.value &&
                                        courseData.courseUsers.value !== "EXTERNAL" &&
                                        courseData.courseUsers.value !== "BOTH")
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "payingUserType",
                                        "EXTERNAL",
                                      )
                                    }
                                  />
                                  External Users
                                </Label>
                              </FormGroup>

                              <FormGroup check className="access-type-radio">
                                <Label check className={`cursor ${
                                    (courseData.courseUsers.value &&
                                      courseData.courseUsers.value !== "RAYCHEM" &&
                                      courseData.courseUsers.value !== "BOTH")
                                      ? "cursor-not-allowed"
                                      : ""
                                  }`}>
                                  <Input
                                    type="radio"
                                    name="payingUserType"
                                    checked={
                                      courseData.payingUserType.value ===
                                      "RAYCHEM"
                                    }
                                    disabled={
                                      (isReadOnly && courseData.courseUsers.value !== "RAYCHEM") || (courseData.courseUsers.value &&
                                        courseData.courseUsers.value !== "RAYCHEM" &&
                                        courseData.courseUsers.value !== "BOTH")
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "payingUserType",
                                        "RAYCHEM",
                                      )
                                    }
                                  />
                                  Raychem
                                </Label>
                              </FormGroup>

                              <FormGroup className="access-type-radio">
                                <Label check className={`cursor ${
                                    (courseData.courseUsers.value &&
                                      courseData.courseUsers.value !== "BOTH")
                                      ? "cursor-not-allowed"
                                      : ""
                                  }`}>
                                  <Input
                                    type="radio"
                                    name="payingUserType"
                                    checked={
                                      courseData.payingUserType.value === "BOTH"
                                    }
                                    disabled={
                                      (isReadOnly && courseData.courseUsers.value !== "BOTH") || (courseData.courseUsers.value &&
                                        courseData.courseUsers.value !== "BOTH")
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "payingUserType",
                                        "BOTH",
                                      )
                                    }
                                  />
                                  Both
                                </Label>
                              </FormGroup>
                            </div>
                            {courseData.payingUserType.error && (
                              <div className="invalid-feedback d-block mt--2">
                                {courseData.payingUserType.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <Label className="form-control-label">
                            Price
                            <span className="text-danger"> *</span>
                          </Label>
                          <div className="mt-2">
                            <FormGroup>
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="fa-solid fa-indian-rupee-sign"></i>
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  name="coursePrice"
                                  type="tel"
                                  inputMode="numeric"
                                  maxLength={10}
                                  value={courseData.coursePrice.value}
                                  placeholder="Enter course price"
                                  onChange={(e) =>
                                    handleInputChange(
                                      "coursePrice",
                                      e.target.value,
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleOnBlur("coursePrice", e.target.value)
                                  }
                                  className={
                                    courseData.coursePrice.error
                                      ? "is-invalid"
                                      : ""
                                  }
                                  disabled={isReadOnly}
                                />
                              </InputGroup>
                              {courseData.coursePrice.error && (
                                <div className="invalid-feedback d-block">
                                  {courseData.coursePrice.error}
                                </div>
                              )}
                            </FormGroup>
                          </div>
                        </Col>
                      </>
                    )}

                    <Col md="4">
                      <div ref={courseTypeRef} />
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Type
                          <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="courseTypeInfo"
                            title="Course Type"
                            content="Defines how the course content is delivered to learners."
                          />
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseType"
                                checked={
                                  courseData.courseType.value === "RECORDED"
                                }
                                onChange={() =>
                                  handleInputChange("courseType", "RECORDED")
                                }
                                disabled={isReadOnly && courseData.courseType.value !== "RECORDED"}
                              />
                              Recorded
                            </Label>
                          </FormGroup>

                          <FormGroup
                            check
                            className={
                              !courseData.accessType.value ||
                              courseData.accessType.value === "FREE"
                                ? "custom-margin-left"
                                : "access-type-negative"
                            }
                          >
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseType"
                                checked={courseData.courseType.value === "LIVE"}
                                onChange={() =>
                                  handleInputChange("courseType", "LIVE")
                                }
                                disabled={isReadOnly && courseData.courseType.value !== "LIVE"}
                              />
                              Live Course
                            </Label>
                          </FormGroup>
                        </div>
                        {courseData.courseType.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseType.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    {/* {courseData.courseType.value === "RECORDED" && (
                      <>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Instructor Name
                            </Label>
                            <Select
                              options={trainerOptions}
                              placeholder="Select Instructor"
                              styles={SELECT_CUSTOM_STYLES}
                              classNamePrefix="react-select"
                              value={
                                trainerOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    courseData.instructorName.value,
                                ) || null
                              }
                              onChange={(selected) => {
                                handleInstructorChange(
                                  selected ? selected.value : "",
                                );
                              }}
                              menuPortalTarget={document.body}
                              menuPosition="absolute"
                              className={
                                courseData.instructorName.error
                                  ? "is-invalid"
                                  : ""
                              }
                            />
                            {courseData.instructorName.error && (
                              <div className="invalid-feedback d-block">
                                {courseData.instructorName.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </>
                    )} */}
                    {courseData.courseType.value === "LIVE" && (
                      <>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Content Delivery Mode
                              <span className="text-danger"> *</span>
                              <InfoPopover
                                targetId="contentDeliveryInfo"
                                title="Content Delivery Mode"
                                content="Select how this course will be delivered"
                              />
                            </Label>

                            <div className="d-flex mt-3">
                              <FormGroup check>
                                <Label
                                  check
                                  className="cursor technical-practical-radio-right"
                                >
                                  <Input
                                    type="radio"
                                    name="contentDeliveryMode"
                                    checked={
                                      courseData.contentDeliveryMode.value ===
                                      "BOTH"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "contentDeliveryMode",
                                        "BOTH",
                                      )
                                    }
                                    disabled={isReadOnly && courseData.contentDeliveryMode.value !== "BOTH"}
                                  />
                                  Online + Offline
                                </Label>
                              </FormGroup>

                              <FormGroup
                                check
                                className="mr-3 access-type-radio"
                              >
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="contentDeliveryMode"
                                    checked={
                                      courseData.contentDeliveryMode.value ===
                                      "OFFLINE"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "contentDeliveryMode",
                                        "OFFLINE",
                                      )
                                    }
                                    disabled={isReadOnly && courseData.contentDeliveryMode.value !== "OFFLINE"}
                                  />
                                  Offline
                                </Label>
                              </FormGroup>

                              <FormGroup
                                check
                                className={
                                  courseData.accessType.value === "FREE"
                                    ? "ml-2"
                                    : "technical-practical-radio"
                                }
                              >
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="contentDeliveryMode"
                                    checked={
                                      courseData.contentDeliveryMode.value ===
                                      "ONLINE"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "contentDeliveryMode",
                                        "ONLINE",
                                      )
                                    }
                                    disabled={isReadOnly && courseData.contentDeliveryMode.value !== "ONLINE"}
                                  />
                                  Online
                                </Label>
                              </FormGroup>
                            </div>
                            {courseData.contentDeliveryMode.error && (
                              <div className="invalid-feedback d-block mt-1">
                                {courseData.contentDeliveryMode.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>

                        {/* {(courseData.contentDeliveryMode.value === "OFFLINE" ||
                          courseData.contentDeliveryMode.value === "BOTH") && (
                          <>
                            <Col md="4">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Assessment Type{" "}
                                  <span className="text-danger">*</span>
                                </Label>

                                <div className="d-flex mt-3">
                                  <FormGroup check className="mr-4">
                                    <Label check className="cursor">
                                      <Input
                                        type="radio"
                                        name="assessmentType"
                                        checked={
                                          courseData.assessmentType?.value ===
                                          "TECHNICAL"
                                        }
                                        onChange={() =>
                                          handleInputChange(
                                            "assessmentType",
                                            "TECHNICAL",
                                          )
                                        }
                                        onBlur={() =>
                                          handleOnBlur(
                                            "assessmentType",
                                            courseData.assessmentType?.value,
                                          )
                                        }
                                        disabled={isReadOnly && courseData.assessmentType?.value !== "TECHNICAL"}
                                      />
                                      Technical
                                    </Label>
                                  </FormGroup>

                                  <FormGroup check className="ml-4">
                                    <Label check className="cursor">
                                      <Input
                                        type="radio"
                                        name="assessmentType"
                                        checked={
                                          courseData.assessmentType?.value ===
                                          "BOTH"
                                        }
                                        onChange={() =>
                                          handleInputChange(
                                            "assessmentType",
                                            "BOTH",
                                          )
                                        }
                                        onBlur={() =>
                                          handleOnBlur(
                                            "assessmentType",
                                            courseData.assessmentType?.value,
                                          )
                                        }
                                        disabled={isReadOnly && courseData.assessmentType?.value !== "BOTH"}
                                      />
                                      Technical + Practical
                                    </Label>
                                  </FormGroup>
                                </div>
                                {courseData.assessmentType?.error && (
                                  <div className="invalid-feedback d-block">
                                    {courseData.assessmentType.error}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </>
                        )} */}
                      </>
                    )}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* prerequisites details */}
            <Card className={"mb-3"}>
              <CardHeader>
                <SectionHeader
                  title="Prerequisites Documents"
                  isOpen={open.prerequisites}
                  onClick={() => toggle("prerequisites")}
                />
              </CardHeader>

              <Collapse isOpen={open.prerequisites}>
                <CardBody className="prerequisites-card-body">
                  <Row>
                    <Col md="3">
                      <FormGroup>
                        <Label className="form-control-label">
                          Does this course require prerequisites?
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="requiredPrerequisiteDocuments"
                                checked={
                                  courseData.requiredPrerequisiteDocuments
                                    .value === true
                                }
                                onChange={() =>
                                  handleInputChange(
                                    "requiredPrerequisiteDocuments",
                                    true,
                                  )
                                }
                                disabled={isReadOnly && courseData.requiredPrerequisiteDocuments.value !== true}
                              />
                              Yes
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="requiredPrerequisiteDocuments"
                                checked={
                                  courseData.requiredPrerequisiteDocuments
                                    .value === false
                                }
                                onChange={() =>
                                  handleInputChange(
                                    "requiredPrerequisiteDocuments",
                                    false,
                                  )
                                }
                                disabled={isReadOnly && courseData.requiredPrerequisiteDocuments.value !== false}
                              />
                              No
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>

                    {courseData.requiredPrerequisiteDocuments.value ===
                      true && (
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Required Documents{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Select
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            options={courseDocumentOptions}
                            placeholder="Select required documents"
                            styles={{
                              ...SELECT_CUSTOM_STYLES,
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "calc(15rem - 2.5rem)",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isFocused
                                  ? "#f0f4ff"
                                  : "transparent",
                                color: "#525f7f",
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: "#e8eaf6",
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: "#32325d",
                              }),
                            }}
                            classNamePrefix="react-select"
                            value={courseData.coursePrerequisiteDocument.value}
                            onChange={handleRequiredDocChange}
                            components={{
                              Option: DocumentOptions,
                              Menu: DocumentMenu,
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="absolute"
                            isClearable
                            className={
                              courseData.coursePrerequisiteDocument.error
                                ? "is-invalid"
                                : ""
                            }
                            isDisabled={isReadOnly}
                          />

                          {courseData.coursePrerequisiteDocument.error && (
                            <div className="invalid-feedback d-block">
                              {courseData.coursePrerequisiteDocument.error}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                    <Col md="5">
                      <FormGroup>
                        <Label className="form-control-label">
                          Additional Notes (visible to the trainees during
                          enrollment)
                        </Label>
                        <Input
                          type="textarea"
                          placeholder="Enter additional notes"
                          name="notes"
                          rows="1"
                          value={courseData.notes.value}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val.length <= 1000) {
                              handleInputChange("notes", val);
                            }
                          }}
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={1000}
                          className={
                            courseData.notes.value.length > 1000
                              ? "is-invalid additional-notes"
                              : "additional-notes"
                          }
                          disabled={isReadOnly}
                        />
                        <div
                          className={`text-right font-size-sm mt-1 ${courseData.notes.value.length > 1000 ? "text-danger" : "text-muted"}`}
                        >
                          {courseData.notes.value.length}/1000
                        </div>
                        {courseData.notes.value.length > 1000 && (
                          <div className="invalid-feedback d-block">
                            Additional notes cannot exceed 1000 characters.
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* lessons */}
            <LessonsSection
              open={open}
              toggle={toggle}
              selectedLanguages={courseData.courseLanguage.value}
              onAddLessonClick={handleAddLessonClick}
              courseId={courseData.id}
              courseType={courseData.courseType.value}
              isBothCourse={courseData.courseUsers.value === "BOTH"}
            />

            {/* Certificate */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Certificate"
                  isOpen={open.certificate}
                  onClick={() => toggle("certificate")}
                />
              </CardHeader>

              <Collapse isOpen={open.certificate}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Certificate Enabled{" "}
                          <span className="text-danger"> *</span>
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check>
                              <Input
                                type="radio"
                                name="enableCertificate"
                                checked={
                                  courseData.enableCertificate.value === true
                                }
                                onChange={() =>
                                  handleInputChange("enableCertificate", true)
                                }
                              />
                              Yes
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="enableCertificate"
                                checked={
                                  courseData.enableCertificate.value === false
                                }
                                onChange={() =>
                                  handleInputChange("enableCertificate", false)
                                }
                              />
                              No
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>
                    {courseData.enableCertificate.value === true && (
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Certificate Template Type{" "}
                            <span className="text-danger"> *</span>
                          </Label>

                          <div className="d-flex flex-nowrap mt-3">
                            {CERTIFICATE_TYPE_OPTIONS.map((option) => (
                              <FormGroup
                                check
                                className="mr-4 flex-shrink-0"
                                key={option.value}
                              >
                                <Label check>
                                  <Input
                                    type="radio"
                                    name="certificateTemplateType"
                                    value={option.value}
                                    checked={
                                      courseData.certificateTemplateType.value
                                        ?.value === option.value
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "certificateTemplateType",
                                        option,
                                      )
                                    }
                                  />
                                  {option.label}
                                </Label>
                              </FormGroup>
                            ))}
                          </div>

                          {courseData.certificateTemplateType.error && (
                            <div className="invalid-feedback d-block mt-2">
                              {courseData.certificateTemplateType.error}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                  {courseData.enableCertificate.value === true && (
                    <>
                      {(certificateType === "COMPLETION" ||
                        certificateType === "BOTH") && (
                        <>
                          <hr className="w-100 my-4" />
                          <Row>
                            {courseData.courseType.value !== "RECORDED" && (
                            <Col md="4">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Certificate Issuance Criteria{" "}
                                  <span className="text-danger"> *</span>
                                </Label>
                                <Select
                                  placeholder="Select attendance requirement"
                                  options={CRITERIA_DEPENDENT_OPTIONS[
                                    "ATTENDANCE"
                                  ].map((opt) => ({
                                    ...opt,
                                    label: `Attendance - ${opt.label}`,
                                  }))}
                                  value={
                                    CRITERIA_DEPENDENT_OPTIONS["ATTENDANCE"]
                                      .map((opt) => ({
                                        ...opt,
                                        label: `Attendance - ${opt.label}`,
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          courseData.criteriaValue.value["ATTENDANCE"]?.value
                                      ) || null
                                  }
                                  onChange={(selected) => {
                                    handleInputChange("criteriaValue", {
                                      ...courseData.criteriaValue.value,
                                      ATTENDANCE: selected,
                                    });
                                    // Clear error for criteria type when value is entered
                                    if (selected?.value) {
                                      setCourseData((prev) => ({
                                        ...prev,
                                        courseCertificateIssuanceCriteria: {
                                          ...prev.courseCertificateIssuanceCriteria,
                                          error: "",
                                        },
                                      }));
                                    }
                                  }}
                                  styles={SELECT_CUSTOM_STYLES}
                                  className={
                                    courseData.courseCertificateIssuanceCriteria
                                      .error
                                      ? "is-invalid"
                                      : ""
                                  }
                                  classNamePrefix="react-select"
                                  menuPortalTarget={document.body}
                                  isClearable
                                  onBlur={() =>
                                    handleOnBlur(
                                      "courseCertificateIssuanceCriteria",
                                      courseData
                                        .courseCertificateIssuanceCriteria
                                        .value,
                                    )
                                  }
                                />
                                {courseData.courseCertificateIssuanceCriteria
                                  .error && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {
                                      courseData
                                        .courseCertificateIssuanceCriteria.error
                                    }
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                            )}

                            <Col md="4">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Certificate Validity{" "}
                                  <span className="text-danger"> *</span>
                                </Label>
                                <Select
                                  options={VALIDITY}
                                  placeholder="Select validity"
                                  styles={SELECT_CUSTOM_STYLES}
                                  classNamePrefix="react-select"
                                  value={
                                    courseData.completionCertificateValidity
                                      .value || null
                                  }
                                  onChange={handleValidityChange}
                                  components={{
                                    Option: ValidityOptionRenderer,
                                    Menu: ValidityMenu,
                                  }}
                                  menuPortalTarget={document.body}
                                  menuPosition="absolute"
                                  isClearable
                                  className={
                                    courseData.completionCertificateValidity
                                      .error
                                      ? "is-invalid"
                                      : ""
                                  }
                                  onBlur={() =>
                                    handleOnBlur(
                                      "completionCertificateValidity",
                                      courseData.completionCertificateValidity
                                        .value,
                                    )
                                  }
                                />
                                {courseData.completionCertificateValidity
                                  .error && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {
                                      courseData.completionCertificateValidity
                                        .error
                                    }
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row className="mt-4">
                            <Col md="12">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Completion Certificate Template{" "}
                                  <span className="text-danger"> *</span>
                                </Label>

                                <div
                                  className={`certificate-template d-flex align-items-start ${
                                    courseData.completionCertificateTemplate
                                      .error
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                >
                                  <div className="d-flex flex-column mr-2">
                                    <Button
                                      color="secondary"
                                      className="mb-3 ml-4 mt-3 btn1"
                                      onClick={() =>
                                        handleTemplateSelection("COMPLETION")
                                      }
                                    >
                                      <i className="fa fa-edit mr-2" />
                                      {certificateTemplatesData.completion?.template ? "Change Template" : "Add Template"}
                                    </Button>

                                    {/* <Button
                                      color="secondary"
                                      className="ml-4 btn1"
                                      disabled={
                                        !certificateTemplatesData.completion
                                          ?.template
                                      }
                                      onClick={() =>
                                        handleDownloadTemplate(
                                          certificateTemplatesData.completion,
                                        )
                                      }
                                    >
                                      <i className="fa fa-download mr-2" />
                                      Download
                                    </Button> */}
                                  </div>

                                  <div className="certificate-preview">
                                    {certificateTemplatesData.completion
                                      ?.template ? (
                                      (() => {
                                        const templateJson = mapBackendTemplateToFrontend(
                                          certificateTemplatesData.completion
                                        );

                                        return (
                                          <div className="certificate-preview-wrapper">
                                            <ThumbnailPreview parsedTemplate={templateJson} />
</div>
                                        );
                                      })()
                                    ) : (
                                      <div className="certificate-placeholder">
                                        No completion certificate template
                                        selected
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {courseData.completionCertificateTemplate
                                  .error && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {
                                      courseData.completionCertificateTemplate
                                        .error
                                    }
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}

                      {(certificateType === "PARTICIPATION" ||
                        certificateType === "BOTH") && (
                        <>
                          <hr className="w-100 my-4" />
                          <Row>
                            <Col md="12">
                              <FormGroup>
                                <Label className="form-control-label">
                                  Participation Certificate Template{" "}
                                  <span className="text-danger"> *</span>
                                </Label>

                                <div
                                  className={`certificate-template d-flex align-items-start ${
                                    courseData.participationCertificateTemplate
                                      .error
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                >
                                  <div className="d-flex flex-column mr-2">
                                    <Button
                                      color="secondary"
                                      className="mb-3 ml-4 mt-3 btn1"
                                      onClick={() =>
                                        handleTemplateSelection("PARTICIPATION")
                                      }
                                    >
                                      <i className="fa fa-edit mr-2" />
                                      {certificateTemplatesData.participation?.template ? "Change Template" : "Add Template"}
                                    </Button>

                                    {/* <Button
                                      color="secondary"
                                      className="ml-4 btn1"
                                      disabled={
                                        !certificateTemplatesData.participation
                                          ?.template
                                      }
                                      onClick={() =>
                                        handleDownloadTemplate(
                                          certificateTemplatesData.participation,
                                        )
                                      }
                                    >
                                      <i className="fa fa-download mr-2" />
                                      Download
                                    </Button> */}
                                  </div>

                                  <div className="certificate-preview">
                                    {certificateTemplatesData.participation
                                      ?.template ? (
                                      (() => {
                                        const templateJson = mapBackendTemplateToFrontend(
                                          certificateTemplatesData.participation
                                        );

                                        return (
                                          <div className="certificate-preview-wrapper">
                                            <ThumbnailPreview parsedTemplate={templateJson} />
</div>
                                        );
                                      })()
                                    ) : (
                                      <div className="certificate-placeholder">
                                        No participation certificate template
                                        selected
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {courseData.participationCertificateTemplate
                                  .error && (
                                  <div className="invalid-feedback d-block mt-2">
                                    {
                                      courseData
                                        .participationCertificateTemplate.error
                                    }
                                  </div>
                                )}
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  )}
                </CardBody>
              </Collapse>
            </Card>

            <Row className="mt-4 mr-4 mb-5">
              <Col className="d-flex flex-wrap justify-content-end align-items-center">
                <Button
                  color="secondary"
                  className="mb-3 mr-2 px-4 py-2"
                  type="button"
                  onClick={() => navigate(getCourseListingRoute(role))}
                >
                  Cancel
                </Button>

                <Button
                  color="primary"
                  className={`btn-deep-blue mb-3 mr-2 px-4 py-2 btn-w-130`}
                  type="submit"
                  disabled={uiState.saveDraftLoading}
                  onClick={handleSaveDraft}
                >
                  Save Draft
                </Button>

                <Button
                  className="px-4 py-2 mb-3 btn-vivid-red btn-w-115"
                  onClick={handlePublish}
                  disabled={uiState.publishLoading}
                >
                  {courseData?.status === "PUBLISHED" ? "Save" : "Publish"}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <AddDocumentModal
        isOpen={modalOpen.addCourse}
        toggle={() => setModalOpen((prev) => ({ ...prev, addCourse: false }))}
        title="Add New Course"
        label="Course Name"
        onSave={handleAddCourseName}
      />

      <AddDocumentModal
        isOpen={modalOpen.addDocument}
        toggle={() => setModalOpen((prev) => ({ ...prev, addDocument: false }))}
        title="Add Document"
        label="Document Name"
        onSave={handleAddCourseDocument}
      />

      <AddDocumentModal
        isOpen={modalOpen.addValidity}
        toggle={() => setModalOpen((prev) => ({ ...prev, addValidity: false }))}
        title="Add Course Validity"
        isValidityModal={true}
        onSave={(data) => {
          const parsedData = {
            ...data,
            durationValue: Number(data.durationValue),
          };

          VALIDITY.splice(VALIDITY.length - 1, 0, {
            label: `${parsedData.durationValue} ${toTitleCase((parsedData.durationType || "").replace(/s$/i, ""))}${parsedData.durationValue > 1 ? "s" : ""}`,
            value: parsedData,
          });

          handleInputChange("completionCertificateValidity", {
            label: `${parsedData.durationValue} ${toTitleCase((parsedData.durationType || "").replace(/s$/i, ""))}${parsedData.durationValue > 1 ? "s" : ""}`,
            value: parsedData,
          });

          notify("success", "Custom validity added successfully");
        }}
      />

      <CertificateTemplateModal
        isOpen={modalOpen?.certificateTemplate}
        toggle={handleCancelTemplate}
        type={certificateTemplatesData.activeType}
        selectedTemplate={
          certificateTemplatesData.activeType === "COMPLETION"
            ? certificateTemplatesData.completion
            : certificateTemplatesData.participation
        }
        onSelect={handleTemplateApply}
      />

      <Modal
        isOpen={uiState.showThumbnailPreview}
        toggle={() =>
          setUiState((prev) => ({
            ...prev,
            showThumbnailPreview: false,
          }))
        }
        centered
        size="lg"
      >
        <ModalHeader
          toggle={() =>
            setUiState((prev) => ({
              ...prev,
              showThumbnailPreview: false,
            }))
          }
        >
          Thumbnail Preview
        </ModalHeader>
        <ModalBody className="text-center">
          {courseData.courseMedia.value &&
            (typeof courseData.courseMedia.value === "string" ? (
              /\.(mp4|webm|ogg|mov|m4v)$/i.test(
                courseData.courseMedia.value,
              ) ? (
                <video
                  src={courseData.courseMedia.value}
                  controls
                  autoPlay
                  className="w-100 modal-preview-media"
                />
              ) : (
                <img
                  src={courseData.courseMedia.value}
                  alt="thumbnail"
                  className="img-fluid modal-preview-media"
                />
              )
            ) : courseData.courseMedia.value?.type?.startsWith("image/") ? (
              <img
                src={URL.createObjectURL(courseData.courseMedia.value)}
                alt="thumbnail"
                className="img-fluid modal-preview-media"
              />
            ) : (
              <video
                src={URL.createObjectURL(courseData.courseMedia.value)}
                controls
                autoPlay
                className="w-100 modal-preview-media"
              />
            ))}
        </ModalBody>
      </Modal>
    </>
  );
}

export default AddCourse;
